import { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

import Modal from '../../shared/Modal';
import text from '../../text.json';
import { removeAlgorithm } from '../../redux/api/algorithm';

const RemoveAlgorithm = ({ handleClose, isOpen, data }) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleRemoveAlgorithm = async () => {
    setIsLoading(true);

    const result = await dispatch(removeAlgorithm(data?.id));

    if (result?.error) {
      setIsLoading(false);
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      isDestructive
      isLoading={isLoading}
      handleClose={handleClose}
      isOpen={isOpen}
      primaryButtonText={text.buttons.remove}
      secondaryButtonText={text.buttons.cancel}
      onPrimaryButtonClick={handleRemoveAlgorithm}
      onSecondaryButtonClick={handleClose}
      modalTitle={text.remove.title.replace('{{name}}', data?.name)}
      titleSx={{ lineBreak: 'anywhere' }}
    >
      <Typography>
        {text.removeAlgorithm.description}
      </Typography>
    </Modal>
  );
};

export default RemoveAlgorithm;

RemoveAlgorithm.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })
};

RemoveAlgorithm.defaultProps = {
  isOpen: false,
  data: {
    id: '',
    name: ''
  }
};
